/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_Add_To_CalendarInputs */



/**
* | output |
* | --- |
* | "Add to calendar" |
*
* @param {Tournament_Add_To_CalendarInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_add_to_calendar = /** @type {((inputs?: Tournament_Add_To_CalendarInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_Add_To_CalendarInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ajouter au calendrier")
	if (locale === "es") return /** @type {LocalizedString} */ ("Añadir al calendario")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Adicionar ao calendário")
	if (locale === "it") return /** @type {LocalizedString} */ ("Aggiungi al calendario")
	return /** @type {LocalizedString} */ ("Add to calendar")
});